import { LoanPreOffer } from '../interfaces/financial-form.interfaces';

export function getLatestPreOffer(
	preOffers?: LoanPreOffer[],
): LoanPreOffer | undefined {
	if (!preOffers?.length) return undefined;

	return preOffers.reduce((latest, current) =>
		new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest,
	);
}
